import { makeStyles, Spinner } from "@fluentui/react-components";
import { getMyWorkspaces } from "api";
import { ManageWorkspacesCardView } from "components/manageWorkspaces/ManageWorkspacesCardView";
import { NavigationPanel } from "components/navigationPanel/NavigationPanel";
import { IWorkspace } from "models/IWorkspace";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setWorkspaces } from "../redux/workspacesSlice";
import designTokens from "../theme/customTheme";

const useStyles = makeStyles({
  container: {
    display: "flex",
    height: "100dvh",
    overflow: "hidden",
    backgroundColor: designTokens.neutral[50],
  },
  navPanel: {
    display: "flex",
    flexWrap: "wrap",
    height: "100dvh",
    backgroundColor: designTokens.neutral[50],
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingLeft: designTokens.spacing[5],
    boxSizing: "border-box",
    backgroundColor: designTokens.neutral[50],
    flex: 1,
  },
  contentWrapper: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flex: 1,
  },
});

export const WorkspacesPage = (): JSX.Element => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect((): void => {
    const fetchWorkspaces = async () => {
      try {
        const data: IWorkspace[] = await getMyWorkspaces();
        dispatch(setWorkspaces(data));
      } catch (error) {
        console.error("Error fetching workspaces:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchWorkspaces();
  }, [dispatch]);

  const renderContent = (): JSX.Element => {
    if (isLoading) {
      return (
        <div
          className={styles.loadingContainer}
          role="status"
          aria-live="polite"
        >
          <Spinner size="large" label="Loading workspaces..." />
        </div>
      );
    }

    return <ManageWorkspacesCardView />;
  };

  return (
    <div className="App">
      <div className={styles.container}>
        <div className={styles.navPanel}>
          <NavigationPanel />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.contentWrapper}>{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};
